import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const CountriesFilter = ({
    countries = [],
    loading = false,
    filters,
    restoreFilterValues,
    onChangeValue = null,
}) => (
    <Field
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='countries'
        placeholder='Country'
        options={countries}
        search
        setValue={restoreFilterValues(filters, 'countries')}
        onChangeValue={onChangeValue}
    />
);

CountriesFilter.propTypes = {
    countries: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object,
    restoreFilterValues: PropTypes.func,
    onChangeValue: PropTypes.func,
};
